import React from 'react';

const styles = {width: '99vw', height: '88vh'};

function PreparacionTerreno() {
    return (
        <iframe
        title='Preparacion de Terreno'
        src="https://geologiaconce.maps.arcgis.com/apps/dashboards/b27ea5eb45ac4f9598b08f56657710da"
        style={styles}>
        </iframe>
    )
}

export default PreparacionTerreno
